export default __webpack_public_path__ + "static/media/237-mark.24f91bc9.svg";